module.exports = __webpack_public_path__ + "img/IMG_2876.727a6134.jpeg";